/**
 * 콘텐츠 상세의 "배포 현황" 한 줄 — 서버가 센 경로(`Asset.reach`)를 사람이 읽는 말로.
 *
 * **세는 일은 서버로 옮겼다**(`apps/server/src/services/content-reach.ts`, 2026-10-12). 예전에는 여기서
 * 플레이리스트·화면 전부·스케줄·그룹·캠페인 다섯 목록을 받아 셌다 — 콘텐츠 하나를 열 때마다 고객사의
 * 편성을 통째로 내려받은 셈이다. 그 규칙(그룹에서 물려받기·스케줄의 기본과 규칙·게재 중인 캠페인, 적게
 * 세지 않기)의 시험도 함께 옮겼다. 여기에는 받은 것을 어떻게 적을지만 남는다.
 */
import type { ContentReachRoute } from './api/client.js';

/** 경로의 이름 — 스케줄 규칙이 콘텐츠를 직접 가리키면 그렇다고 밝힌다(플레이리스트 목록에서 찾지 않게). */
export function reachRouteTitle(route: Pick<ContentReachRoute, 'kind' | 'name'>): string {
  return route.kind === 'schedule' ? `스케줄 ‘${route.name}’ 의 규칙` : route.name;
}

/**
 * 경로 아래 한 줄 — 나가는 화면과, 직접 배정이 아니면 어떻게 닿는지.
 *
 * **"재생 화면 없음" 을 비워 두지 않는다.** 플레이리스트에 들어 있지만 아무 화면에도 닿지 않는 것(꺼 둔
 * 줄·배정 안 된 플레이리스트)은 지워도 되는지 판단할 때 가장 중요한 사실이다.
 */
export function reachRouteLine(route: Pick<ContentReachRoute, 'displays' | 'via'>): string {
  const screens = route.displays.length > 0 ? route.displays.map((display) => display.name).join(', ') : '재생 화면 없음';
  return route.via.length > 0 ? `${screens} · ${route.via.join(', ')} 경유` : screens;
}
